import { DAIMI_USA_INTRO, DAIMI_USA_SLUG } from '@/content/daimiUsa'
import { LABS_EYEBROW, cover, pdf } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The third report with a designed page of its own — asked for on
  // 2026-08-27 with a full-page screenshot of the live USA Edition page as the
  // reference. See `content/daimiUsa.ts` and `pages/DaimiUsa.tsx`. The index
  // card still reads this entry's cover and title.
  slug: DAIMI_USA_SLUG,
  title: 'Digital & AI Maturity Report USA Edition',
  eyebrow: LABS_EYEBROW,
  headline: 'Digital & AI Maturity Report 2026: USA Edition',
  cover: cover('daimi-report-2026-usa-cover', 'Digital & AI Maturity Report USA Edition'),
  // The page's own opening paragraph, so the search result and the page agree
  // — `prerender.tsx` takes the meta description from `body[0]`. It used to be
  // the series description, which is what `stillToCome({ copy: true })` said.
  body: DAIMI_USA_INTRO.body,
  download: pdf('f28f4174-23b3-4b9b-beb9-13d2cee6d912-Digitopia Digital _ AI Maturity Report 2026 USA.pdf'),
  layout: 'usa-edition',
  // Nothing left for `stillToCome` to say: file, cover and its own words. What
  // is still open about it is section-by-section on its page, and
  // `daimiUsaChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 1
